import styled from 'styled-components';

export const StyledHeader = styled.h2`
  text-align: center;
`;
